export default __webpack_public_path__ + "static/media/bgVector.af979b0d.svg";